import { useTheme } from '@mui/material/styles';
import { ErrorFallbackScreen } from 'components/screens';
import {
  Assignments,
  AssignmentsContextProvider,
  AssignmentsHeader
} from 'modules/assignments';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const AssignmentsPage = () => {
  const theme = useTheme();
  const { isEnabled: isAssignmentManagementEnabled, isLoading } =
    useFeatureToggle(FeatureFlag.PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED);

  if (isLoading) return null;

  if (!isAssignmentManagementEnabled) {
    return <ErrorFallbackScreen />;
  }

  return (
    <AssignmentsContextProvider>
      <Layout
        childrenStyles={{
          p: '0 0 47px 0',
          [theme.breakpoints.up('sm')]: {
            px: 0,
            maxWidth: '100%'
          }
        }}
        header={<AssignmentsHeader />}
        withFooter
      >
        <Assignments />
      </Layout>
    </AssignmentsContextProvider>
  );
};
